import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useOutletContext, useParams } from 'react-router-dom'
import {
    CreatePlanoInput,
    PlanoFixo,
    planos,
    updatePlanoSchema,
} from 'service/api'
import { toast } from 'sonner'
import { FormPlano } from '../forms/FormPlano'

export default function EditarPlano() {
    const { planoId } = useParams()

    const { data } = useOutletContext<{ data?: PlanoFixo[] }>()
    const plano = data?.find(item => item.id === Number(planoId))

    const { mutateAsync, isLoading } = planos.mutations.useUpdate({
        invalidateQuery: true,
    })

    function handleSubmit(values: CreatePlanoInput) {
        return mutateAsync(
            { id: plano!.id, ...values },
            {
                onSuccess: () => {
                    toast.success('Plano atualizado com sucesso!')
                },
                onError: ({ statusCode, message }) => {
                    if (statusCode === 422) {
                        ;(message as string[]).forEach(error =>
                            toast.error(error),
                        )
                    } else {
                        toast.error(message)
                    }
                },
            },
        )
    }

    if (!plano) return null

    return (
        <Dialog.Root
            open={hasPermission(['update', 'Planos e preços'])}
            width="xl"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={updatePlanoSchema}
            defaultValues={{
                periodicity: plano.periodicity,
                limiteFuncionarios: plano.limiteFuncionarios,
                precoReais: (plano.price / 100).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
            }}
        >
            <Dialog.Title>Editar plano</Dialog.Title>
            <Dialog.Content>
                <FormPlano />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
